import React from 'react';
import { Col } from 'antd';
import { CompanyFormItem } from '@/components/views/Resolution886/components/Form';

export function Company(): JSX.Element {
	return (
		<Col xs={24}>
			<CompanyFormItem fieldName="company_id" required={false} last_review={true} />
		</Col>
	);
}
